import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'familyPlanLanding.unlock.heading',
		defaultMessage: 'Premium benefits for the whole family',
		description: 'Heading for Calm Premium feature set section',
	},
	subheading: {
		id: 'familyPlanLanding.unlock.subheading',
		defaultMessage: 'With Calm Premium Family, members unlock full access to Calm’s content library',
		description: 'Subheading for Calm Premium feature set section',
	},
	subheadingAccept: {
		id: 'familyPlanLanding.unlock.subheadingAccept',
		defaultMessage: 'As a Family plan member, you’ll unlock full access to Calm’s content library',
		description: 'Subheading for Calm Premium feature set section',
	},
	basicHeading: {
		id: 'familyPlanLanding.unlock.basicHeading',
		defaultMessage: 'Basic',
		description: 'Heading for basic features column',
	},
	premiumHeading: {
		id: 'familyPlanLanding.unlock.premiumHeading',
		defaultMessage: 'Premium',
		description: 'Heading for premium features column',
	},
	limitedText: {
		id: 'familyPlanLanding.unlock.limitedText',
		defaultMessage: 'Limited',
		description: 'Text for "limited"',
	},
	unlimitedText: {
		id: 'familyPlanLanding.unlock.unlimitedText',
		defaultMessage: 'Unlimited',
		description: 'Text for "unlimited"',
	},
	feature1: {
		id: 'familyPlanLanding.unlock.feature1',
		defaultMessage: 'Access to great content',
		description: 'Feature of Calm',
	},
	feature2: {
		id: 'familyPlanLanding.unlock.feature2',
		defaultMessage: 'Hundreds of guided meditations',
		description: 'Feature of Calm',
	},
	feature3: {
		id: 'familyPlanLanding.unlock.feature3',
		defaultMessage: 'Soothing Sleep Stories',
		description: 'Feature of Calm',
	},
	feature4: {
		id: 'familyPlanLanding.unlock.feature4',
		defaultMessage: 'Exclusive music for focus, relaxation, and sleep',
		description: 'Feature of Calm',
	},
	feature5: {
		id: 'familyPlanLanding.unlock.feature5',
		defaultMessage: 'Calming nature sounds',
		description: 'Feature of Calm',
	},
	feature6: {
		id: 'familyPlanLanding.unlock.feature6',
		defaultMessage: 'Gratitude and mood check-ins',
		description: 'Feature of Calm',
	},
	feature7: {
		id: 'familyPlanLanding.unlock.feature7',
		defaultMessage: 'Masterclasses on peak performance',
		description: 'Feature of Calm',
	},
	feature8: {
		id: 'familyPlanLanding.unlock.feature8',
		defaultMessage: 'Lullabies and Sleep Stories for kids',
		description: 'Feature of Calm',
	},
	feature9: {
		id: 'familyPlanLanding.unlock.feature9',
		defaultMessage: 'New content every week',
		description: 'Feature of Calm',
	},
});
